import { map, OperatorFunction } from 'rxjs';

import { ApiResponseBase } from '../types';

import { assertNonNull } from './assert-non-null';

export function extractDataNonNull<T, M>(): OperatorFunction<ApiResponseBase<T, M>, T> {
  return map((res) => {
    assertNonNull(res.data);
    return res.data;
  });
}
